export class RegexValidators {
  public static readonly EMAIL = new RegExp(
    // eslint-disable-next-line no-useless-escape
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );
  public static readonly MIN_2_MAX_50_LETTERS = new RegExp(
    // eslint-disable-next-line no-useless-escape
    /^(?! )[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð.,\"'\- ]{2,50}(?<! )$/
  );
  public static readonly MIN_2_MAX_50_LETTERS_HE = new RegExp(
    // eslint-disable-next-line no-useless-escape
    /^(?! )[a-zA-Z\u0590-\u05FFàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð.,\"'\- ]{2,50}(?<! )$/
  );

  public static readonly MIN_2_MAX_50_LETTERS_HEBREW = new RegExp(/^[ ,.'אבגדהוזחטיךכלםמןנסעףפץצקרשת]{2,50}$/);
  public static readonly NUMBERS = new RegExp(/^\d+$/);
  public static readonly NUMBERS_ONLY = new RegExp('[^0-9]', 'g');
  public static readonly NUMBERS_ONLY_WITH_ALLOWED_CHARS = new RegExp('^[0-9.!$_%^-]+$');
  public static readonly PHONE_10_DIGITS_LENGTH = new RegExp(/^\d{10,12}$/);
  public static readonly PHONE_20_DIGITS_LENGTH = new RegExp(/^\d{4,12}$/);
  public static readonly PHONE_4_DIGITS_LENGTH = new RegExp(/^\d{4,15}$/);
  public static readonly AU_PHONE_NUMBER = new RegExp(/^(04)\d{8}$/);
  public static readonly PHONE_ISRAEL = new RegExp(/^0\d{9}$/);
  public static readonly ALPHANUMERIC = new RegExp(/^[a-zA-Z0-9]+$/);
  public static readonly POSTCODE_REGEXP: RegExp = /^[0-9]{4}$/;
  public static readonly ALPHANUMERIC_WITH_SPACES_AND_PARENTHESIS = /^[a-zA-Z0-9\s()]+$/;
  public static readonly START_WITH_ZERO = /^0\d+/;
  public static readonly NOSPECIALCHARACTERS = new RegExp(/^[\p{L}\p{N}]+$/u);
  public static readonly LETTERS_ONLY = /^[A-Za-z]+$/;
}
